import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../common/validationservice';
import { MainAppComponent } from '../../layout/layout.component';
import { PageResultDto, CustomerModel } from '../../common/viewModels/Admin/CustomerModel';
import { FormatService } from '../../common/formatService';
import 'rxjs/add/operator/map';
import { AmplifyService } from '../../common/amplify-service';
import { PagerService } from '../../common/pagerService';
import { DeletedDataSearchModel } from '../../common/viewModels/Analysis/SampleModel';


@Component({
    selector: 'deleteddata',
    templateUrl: './deleteddata.component.html',
    styleUrls: ['./deleteddata.component.scss']
})

export class DeletedData implements OnInit {

    pager: any = {};
    pagedItems: any[];
    pageResult: PageResultDto;
    mainComponent: any;
    searchFields: DeletedDataSearchModel = new DeletedDataSearchModel();
    length: number = 0;
    isNoRecords: boolean = true;
    customers: CustomerModel;
    deltedDataSearchForm: FormGroup;
    isSampleScreen: boolean = true;
    colspan: number = 9;
    screenName: string = "Sample";
    id: number;
    labs: any;
    pageSize: number = 10;

    ngOnInit(): void {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageSize = this.pageSize;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pageSrvc.pageSizeOptions;
        this.createSearchForm();
        if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
            this.deltedDataSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
        if (curUserDetails && curUserDetails.DefaultCompanyId && curUserDetails.UserTypeId == 3) {
            this.deltedDataSearchForm.controls['CustomerId'].setValue(parseInt(curUserDetails.DefaultCompanyId));
        }
        this.getCustomers();
        this.getLabs();
        this.constructSearchData();
        this.setPage(this.pager);
    }

    constructor(public _router: Router, private _formBuilder: FormBuilder, private _formatService: FormatService,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _validationService: ValidationService, private _mApp: MainAppComponent, private _pageSrvc: PagerService,
        private _toastrService: ToastrService, private _amplifyService: AmplifyService) {
        this.mainComponent = _mApp;
    }

    createSearchForm() {
        this.deltedDataSearchForm = this._formBuilder.group({
            CustomerId: [''],
            JobCardNumber: [''],
            LabIds: [''],
            ScreenTypeId: [1]
        })
    }


    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.getDeletedData(this.pager);

    }

    getDeletedData(page: any) {
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize;
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.GetDeletedSamplesOrJobCards, this.searchFields)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    var response = data.json();
                    this.length = response.PageResult.TotalRecords;
                    this.pagedItems = response.Result;
                    this.isNoRecords = !(response.Result.length > 0)
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, "")
                }
            )
    }

    getCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.customers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    getLabs() {
        this._http.get(this._appUrl.GetLabsMinInfoList)
            .subscribe(
                data => {
                    if(this._mApp.userTypeId == 2) {
                        let lstLabs = data.json().Result;
                        if (this._mApp.currentUserLabIds && lstLabs)
                        lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
                        this.labs = lstLabs;
                    }
                    else {
                        this.labs = data.json().Result;
                    }
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    onSubmit() {
        this.pager.pageIndex = 0;
        this.constructSearchData();
        this.setPage(this.pager);
    }

    constructSearchData() {
        let searchDto = this.deltedDataSearchForm.value;
        this.searchFields.CustomerId = searchDto.CustomerId;
        this.searchFields.LabIds = searchDto.LabIds;
        this.searchFields.JobCardNumber = searchDto.JobCardNumber;
        this.searchFields.ScreenTypeId = searchDto.ScreenTypeId;
    }

    constructStaticData() {

    }

    onReset() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        if (curUserDetails && curUserDetails.DefaultCompanyId && curUserDetails.UserTypeId == 3) {
            this.deltedDataSearchForm.controls['CustomerId'].setValue(parseInt(curUserDetails.DefaultCompanyId));
        }
        this.deltedDataSearchForm.controls['JobCardNumber'].setValue('');
        this.deltedDataSearchForm.controls['LabIds'].setValue('');
        this.searchFields.JobCardNumber = '';
        // this.searchFields.CustomerId = 0;
        this.searchFields.LabIds = [];
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.getCustomers();
        this.setPage(this.pager);
        if (this._mApp.userTypeId == 2) {
            var currentUser = JSON.parse(localStorage.getItem('currentUser'));
            let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
            this.deltedDataSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
    }

    changeScreenType(screenTypeId) {
        if (screenTypeId == 1) {
            this.screenName = "Sample";
            this.isSampleScreen = true;
        }
        else {
            this.isSampleScreen = false;
            this.screenName = "JobCard";
        }
        this.searchFields.ScreenTypeId = screenTypeId;
        this.onReset();

    }

    activeItem(itemId) {
        this.id = itemId;
    }

    activeItemById(id) {
        this._mApp.ShowLoader();
        var screenTypeId = this.searchFields.ScreenTypeId;
        this._http.get(this._appUrl.ActivateSampleOrJobCard + screenTypeId + "&sampleOrJobCardId=" + id)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    this.setPage(this.pager);
                    this._toastrService.success(res.json().Result, '');
                }, error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }


}